"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { DeleteThoughtsRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { deleteThoughts } from "../api/deleteThoughts";
import { thoughtKeys } from "../queries/keys";

export default function useDeleteThoughtsMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: DeleteThoughtsRequest) =>
      deleteThoughts(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: thoughtKeys.all });
    },
  });
}
